import { render, staticRenderFns } from "./WarehouseV2.vue?vue&type=template&id=cc43ea20&"
import script from "./WarehouseV2.vue?vue&type=script&lang=js&"
export * from "./WarehouseV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports